module.exports = __webpack_public_path__ + "static/media/PERFECT_logo_newcolor.ed0b4553.svg";